import { useNavigate } from "react-router";
import { bemCN } from "../../config/bem-classname";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import "./start-page.scss";
import { links } from "../../config/links";
import {
  localStorageService,
  LocalStorageVariableName,
} from "../../services/localStorage-service";
const startPageCn = bemCN("start-page");

export const StartPage = () => {
  const navigate = useNavigate();

  const onStartClick = () => {
    navigate(links.stories);
    // if (localStorageService.getValue(LocalStorageVariableName.token)) {
    //   navigate(links.stories);
    // } else {
    //   navigate(links.login);
    // }
  };

  return (
    <div className={startPageCn()}>
      <Button
        onClick={onStartClick}
        text="Начать"
        color={ButtonColors.crimson}
        size={ButtonSizes.big}
      />
    </div>
  );
};
